import React, { useContext } from 'react';
import { AppContext } from '../../contexts/AppContext';
import { ButtonDropdown, ButtonDropdownProps } from '@amzn/awsui-components-core';
import BrowserHistory from '../utils/BrowserHistory';
import RouterPaths from '../../common/RouterPaths';
import constants from '../../common/constants';
import {
  BarRaiserTechDomains,
  ContentUserRole,
  TechDomain,
  UserRoles,
  TechDomainDisplayNames,
} from '@amzn/awscat-pattern-library-service-model';
import { isBarRaiser } from '../utils/BarRaiser';
import kebabCase from 'kebab-case';

const HeaderDashboardDropdown = () => {
  const appContext = useContext(AppContext);
  const userProfile = appContext?.authnInfo?.userProfile;

  const handleDashboardClick = (event: CustomEvent<ButtonDropdownProps.ItemClickDetails>) => {
    const dashboardTitle = event.detail.id;
    const splitDashboardTitle = dashboardTitle.split(' - ');
    switch (splitDashboardTitle[0]) {
      case constants.ADMIN_DASHBOARD:
        BrowserHistory.push(RouterPaths.ADMIN_DASHBOARD);
        break;
      case constants.TECH_WRITER_DASHBOARD_BOARD:
        BrowserHistory.push(RouterPaths.TECH_WRITER_DASHBOARD_NEW);
        break;
      case constants.PUBLISH_PENDING_CONTENTS:
        BrowserHistory.push(RouterPaths.CONTENT_TO_PUBLISH);
        break;
      case constants.PUBLISHER_COMMENTS_HEADER:
        BrowserHistory.push(RouterPaths.MY_PENDING_COMMENTS);
        break;
      case constants.BAR_RAISER_DASHBOARD:
        // @ts-expect-error TS7053 - strict migration
        const techDomain = TechDomain[splitDashboardTitle[1]];
        const techDomainUrl = techDomain ? kebabCase(techDomain) : '';
        const path = RouterPaths.BAR_RAISER_DASHBOARD_PREFIX + techDomainUrl;
        BrowserHistory.push(path);
        break;
      default:
        break;
    }
  };

  const dropDownItems = [];
  if (userProfile?.roles?.has(UserRoles.Admin)) {
    dropDownItems.push({ text: constants.ADMIN_DASHBOARD, id: constants.ADMIN_DASHBOARD });
  }
  if (userProfile?.roles?.has(UserRoles.TechWriter)) {
    dropDownItems.push({
      text: constants.TECH_WRITER_DASHBOARD_BOARD,
      id: constants.TECH_WRITER_DASHBOARD_BOARD,
    });
  }
  if (userProfile?.roles?.has(UserRoles.Publisher)) {
    dropDownItems.push(
      { text: constants.PUBLISH_PENDING_CONTENTS, id: constants.PUBLISH_PENDING_CONTENTS },
      { text: constants.PUBLISHER_COMMENTS_HEADER, id: constants.PUBLISHER_COMMENTS_HEADER },
    );
  }
  // @ts-expect-error TS2345 - strict migration
  if (isBarRaiser(userProfile)) {
    // @ts-expect-error TS18048 - strict migration
    const barRaiserRoleConfigs = userProfile.contentRoles.filter(
      (r) => r.contentRole === ContentUserRole.BarRaiser,
    );
    barRaiserRoleConfigs.forEach((c) => {
      const techDomain = c.filter?.metadataAttributeValue;
      if (
        // @ts-expect-error TS2345 - strict migration
        ['mainTechDomain'].includes(c.filter?.metadataAttributeName) &&
        // @ts-expect-error TS2345 - strict migration
        BarRaiserTechDomains.includes(techDomain)
      ) {
        // @ts-expect-error TS2538 - strict migration
        const techDomainDisplayName = TechDomainDisplayNames.get(TechDomain[techDomain]);
        dropDownItems.push({
          text: `${constants.BAR_RAISER_DASHBOARD} - ${techDomainDisplayName}`,
          id: `${constants.BAR_RAISER_DASHBOARD} - ${techDomain}`,
        });
      }
    });
  }
  if (!dropDownItems.length) {
    return null;
  }
  return (
    <ButtonDropdown onItemClick={handleDashboardClick} items={dropDownItems}>
      Dashboard
    </ButtonDropdown>
  );
};

export default HeaderDashboardDropdown;
